export default {
  // Page Title
  'products.title': 'Find & Customize Cosmetic Packaging',
  'products.subtitle': 'Search verified packaging products, compare specifications, and request custom packaging quotes.',

  // Search
  'products.pageTitle': 'Find Your Cosmetic Packaging',
  'products.search.placeholder': 'Search by product name, capacity, material, or SKU',
  'products.search.button': 'Search',
  'products.search.imageSearch': 'Search by Image',

  // Category Tabs
  'products.category.airless': 'Airless Bottles',
  'products.category.pump': 'Pump Bottles',
  'products.category.spray': 'Spray Bottles',
  'products.category.dropper': 'Dropper Bottles',
  'products.category.cream': 'Cream Jars',
  'products.category.foam': 'Foam Bottles',
  'products.category.tubes': 'Tubes',
  'products.category.caps': 'Caps & Pumps',
  'products.category.sample': 'Sample Containers',
  'products.category.aluminum': 'Aluminum Containers',
  'products.category.glass': 'Glass Containers',
  'products.category.pet': 'PET / PETG Bottles',
  'products.category.all': 'All',

  // Sidebar
  'products.sidebar.title': 'Categories',
  'products.sidebar.noCategories': 'No categories available',

  // Category tree (sidebar)
  'products.categories.glass': 'Glass Packaging',
  'products.categories.glass.toner': 'Toner Bottle',
  'products.categories.glass.creamJar': 'Glass Cream Jar',
  'products.categories.glass.ampoule': 'Glass Ampoule Bottle',
  'products.categories.petg': 'PETG / PET Plastic',
  'products.categories.petg.serum': 'Serum / Essence Bottle',
  'products.categories.petg.toner': 'Toner Bottle',
  'products.categories.petg.creamJar': 'PETG / PET Cream Jar',
  'products.categories.petg.shampoo': 'Large Shampoo Bottle',
  'products.categories.airless': 'Airless Packaging',
  'products.categories.airless.serum': 'Serum / Essence Bottle',
  'products.categories.airless.toner': 'Airless Toner Bottle',
  'products.categories.airless.creamJar': 'Airless Cream Jar',
  'products.categories.specialty': 'Specialty Packaging',
  'products.categories.specialty.syringe': 'Syringe-Type Applicator',
  'products.categories.specialty.powder': 'Powder Container',
  'products.categories.specialty.cleansingPad': 'Cleansing Pad Jar',
  'products.categories.specialty.sample': 'Sample Container',
  'products.categories.specialty.accessories': 'Accessories / Consumables',
  'products.categories.tubes': 'Tubes',
  'products.categories.tubes.eyeCream': 'Eye Cream Tube',
  'products.categories.tubes.flipScrew': 'Flip / Screw-Cap Tube',
  'products.categories.tubes.brushSponge': 'Brush / Sponge Applicator',
  'products.categories.tubes.rollerComb': 'Roller / Comb Applicator',
  'products.categories.tubes.airlessPump': 'Airless Pump Tube',
  'products.categories.tubes.makeup': 'Makeup Tube',
  'products.categories.tubes.toothpaste': 'Toothpaste Tube',
  'products.categories.tubes.aluminum': 'Aluminum Tube',
  'products.categories.pumpsDroppers': 'Pumps & Droppers',
  'products.categories.pumpsDroppers.mist': 'Fine Mist Sprayer',
  'products.categories.pumpsDroppers.dropper': 'Dropper',
  'products.categories.pumpsDroppers.oilPump': 'Oil Pump',
  'products.categories.pumpsDroppers.serumPump': 'Serum / Essence Pump',
  'products.categories.pumpsDroppers.shampooPump': 'Shampoo Pump',
  'products.categories.pumpsDroppers.trigger': 'Trigger Sprayer',
  'products.categories.pumpsDroppers.caps': 'Caps / Closures',
  'products.categories.sheetPouch': 'Sheet Material & Pouch',
  'products.categories.sheetPouch.mask': 'Sheet Mask / Pouch',
  'products.categories.sheetPouch.cleansing': 'Cleansing / Skincare Material',
  'products.categories.sheetPouch.specialty': 'Specialty Pouch',
  'products.categories.sheetPouch.pouch': 'Pouch',
  'products.categories.boxes': 'Boxes / Cartons',
  'products.categories.boxes.folding': 'Folding / Unit Carton',
  'products.categories.boxes.giftSet': 'Gift Set Box / Set Box',
  'products.categories.boxes.round': 'Round / Polygonal Box',
  'products.categories.boxes.outer': 'Outer Carton',
  'products.categories.makeup': 'Makeup Packaging',
  'products.categories.makeup.cushion': 'Cushion Compact',
  'products.categories.makeup.lip': 'Lip Packaging',
  'products.categories.makeup.puff': 'Cosmetic Puff',
  'products.categories.makeup.other': 'Other Makeup Packaging',
  'products.categories.misc': 'Miscellaneous Packaging',
  'products.categories.misc.labels': 'Labels / Stickers',
  'products.categories.misc.pvcFilm': 'PVC Shrink Film',

  // Filters
  'products.filters.title': 'Filters',
  'products.filters.category': 'Category',
  'products.filters.capacity': 'Capacity',
  'products.filters.material': 'Material',
  'products.filters.shape': 'Shape',
  'products.filters.neckSize': 'Neck Size / Closure Size',
  'products.filters.usage': 'Usage / Application',
  'products.filters.priceRange': 'Price Range',
  'products.filters.moqRange': 'MOQ Range',
  'products.filters.moqAvailable': 'MOQ Available',
  'products.filters.inStock': 'In Stock',
  'products.filters.clearAll': 'Clear Filters',
  'products.filters.apply': 'Apply Filters',
  'products.filters.showResults': 'Show Results',
  'products.filters.mobileTitle': 'Filter Products',
  'products.filters.supplyType': 'Supply Type',
  'products.filters.allSupplyTypes': 'All Supply Types',
  'products.filters.availabilityStatus': 'Availability',
  'products.filters.allAvailability': 'All Availability',

  // Capacity options
  'products.capacity.5ml': '5ml',
  'products.capacity.10ml': '10ml',
  'products.capacity.15ml': '15ml',
  'products.capacity.20ml': '20ml',
  'products.capacity.30ml': '30ml',
  'products.capacity.50ml': '50ml',
  'products.capacity.60ml': '60ml',
  'products.capacity.100ml': '100ml',
  'products.capacity.120ml': '120ml',
  'products.capacity.150ml': '150ml',
  'products.capacity.200ml': '200ml',
  'products.capacity.250ml': '250ml',
  'products.capacity.300ml': '300ml',
  'products.capacity.500ml': '500ml',

  // Material options
  'products.material.pet': 'PET',
  'products.material.petg': 'PETG',
  'products.material.pp': 'PP',
  'products.material.pe': 'PE',
  'products.material.abs': 'ABS',
  'products.material.acrylic': 'Acrylic',
  'products.material.glass': 'Glass',
  'products.material.aluminum': 'Aluminum',
  'products.material.pcr': 'PCR',
  'products.material.mono': 'Mono-material',

  // Toolbar
  'products.toolbar.found': '{{count}} packaging products found',
  'products.toolbar.found_one': '{{count}} packaging product found',
  'products.toolbar.clearFilters': 'Clear Filters',
  'products.toolbar.sortBy': 'Sort by',
  'products.toolbar.gridView': 'Grid',
  'products.toolbar.listView': 'List',
  'products.toolbar.allCategories': 'All Categories',

  // Sort options
  'products.sort.newest': 'Newest',
  'products.sort.nameAsc': 'Product Name A-Z',
  'products.sort.nameDesc': 'Product Name Z-A',
  'products.sort.priceLow': 'Lowest Estimated Price',
  'products.sort.priceHigh': 'Highest Estimated Price',
  'products.sort.capacityLow': 'Capacity: Low to High',
  'products.sort.capacityHigh': 'Capacity: High to Low',
  'products.sort.recentlyUpdated': 'Recently Updated',

  // Availability Status
  'products.availability.available': 'Available',
  'products.availability.limitedStock': 'Limited Stock',
  'products.availability.checkAvailability': 'Check Availability',
  'products.availability.madeToOrder': 'Made to Order',

  // Product Card
  'products.card.sku': 'SKU: {{sku}}',
  'products.card.noSku': 'SKU: —',
  'products.card.moq': 'MOQ: {{moq}} pcs',
  'products.card.moqFree': 'Small Qty (Free)',
  'products.card.finishedProduct': 'Finished Product',
  'products.card.delivery': 'Delivery: {{days}} days',
  'products.card.moqShort': 'MOQ: {{moq}}',
  'products.card.leadTime': 'Lead Time',
  'products.card.leadTimeDaysSingle': '{{days}} days',
  'products.card.leadTimeDaysRange': '{{min}}–{{max}} days',
  'products.card.capacityMl': '{{ml}}ml',
  'products.card.deliveryDays': 'Delivery: {{days}} days',
  'products.card.deliveryLabel': 'Delivery',
  'products.card.orderMethod': 'Order Type',
  'products.card.basePrice': 'Base Price',
  'products.card.specsSeparator': '|',
  'products.card.priceApprox': 'Approx. {{currency}} {{price}} / pc',
  'products.card.priceEstimated': 'Estimated from {{currency}} {{price}} / pc',
  'products.card.priceNote': 'Final quote after review',
  'products.card.requestQuote': 'Request Quote',
  'products.card.viewDetails': 'View Details',
  'products.card.aiPreview': 'AI Preview',
  'products.card.checkAvailability': 'Check Availability',
  'products.card.saved': 'Saved',
  'products.card.save': 'Save',
  'products.card.loginToSave': 'Sign in to save',

  // Specs
  'products.specs.capacity': 'Capacity',
  'products.specs.material': 'Material',
  'products.specs.shape': 'Shape',
  'products.specs.neckSize': 'Neck Size',
  'products.specs.size': 'Size',

  // Empty State
  'products.empty.title': 'No products found',
  'products.empty.message': 'Try adjusting your filters or upload a reference image to find similar packaging.',
  'products.empty.noAvailable': 'No available products found. Try adjusting your filters or check other availability options.',
  'products.empty.noLimitedStock': 'No limited-stock products found. Try adjusting your filters.',
  'products.empty.noCheckAvailability': 'No products requiring availability check found. Try adjusting your filters.',
  'products.empty.noMadeToOrder': 'No made-to-order products found. Try adjusting your filters.',
  'products.empty.clearFilters': 'Clear Filters',
  'products.empty.imageSearch': 'Find Similar by Image',

  // Pagination
  'products.pagination.showing': 'Showing {{start}}–{{end}} of {{total}}',
  'products.pagination.prev': 'Previous',
  'products.pagination.next': 'Next',

  // Bottom CTA
  'products.bottomCTA.title': 'Need help finding the right packaging?',
  'products.bottomCTA.text': 'Upload a reference image or request a custom packaging quote from our team.',
  'products.bottomCTA.imageSearch': 'Find Similar by Image',
  'products.bottomCTA.requestQuote': 'Request Quote',

  // Market indicator
  'products.market.label': 'Market',
  'products.currency.label': 'Currency',
  'products.baseCurrency.label': 'Base quote currency',

  // Search status
  'products.searchingByImage': 'Searching by image...',
  'products.searchingProducts': 'Searching products...',
  'products.imageSearchResult': '{{count}} similar products found from your uploaded image.',
  'products.textSearchResult': '{{count}} products found for "{{query}}".',
  'products.noSimilarProducts': 'No similar products found. Try another image or adjust filters.',
  'products.noProductsFoundForQuery': 'No products found for "{{query}}". Try adjusting your search.',
  'products.imageSearchFailed': 'Image search failed. Please try again with another image.',
  'products.imageSearchUnavailable': 'Image search server is currently unavailable.',
  'products.apiRouteNotFound': 'API route not found. Please check Cursor API route /api/customer/image-search and proxy settings.',
  'products.showingAllProducts': 'Showing all products instead.',
  'products.textSearchLocalFallback': 'Server search unavailable. Showing {{count}} local results for "{{query}}".',
  'products.searchFailed': 'Search failed. Please try again.',
  'products.clearSearch': 'Clear search',
  'products.imageSearchLabel': 'Image Search',
  'products.textSearchLabel': 'Text Search',

  // Image Search Flow
  'products.imageSearch.uploaded': 'Image uploaded.',
  'products.imageSearch.jobCreated': 'Image search job created.',
  'products.imageSearch.startingEdgeFunction': 'Starting Edge Function...',
  'products.imageSearch.analyzingImage': 'Analyzing image...',
  'products.imageSearch.searchingSimilar': 'Searching similar products...',
  'products.imageSearch.preparingResults': 'Preparing results...',
  'products.imageSearch.completed': '{{count}} similar products found from your uploaded image.',
  'products.imageSearch.failed': 'Image search failed. Please try another image.',
  'products.imageSearch.signInRequired': 'Please sign in to use image search.',
  'products.imageSearch.invalidFile': 'Only JPG, PNG, or WEBP files are supported.',
  'products.imageSearch.tooLarge': 'Image must be under 10MB.',
  'products.imageSearch.timeout': 'Image search is taking longer than expected. You can keep this page open or try again.',
  'products.imageSearch.edgeFunctionFailed': 'Edge Function could not be started. Please try again.',

  // Image Search Monitor
  'products.imageSearch.monitor.title': 'Image Search Monitor',
  'products.imageSearch.monitor.jobId': 'Job ID',
  'products.imageSearch.monitor.status': 'Status',
  'products.imageSearch.monitor.step': 'Step',
  'products.imageSearch.monitor.progress': 'Progress',
  'products.imageSearch.monitor.message': 'Message',
  'products.imageSearch.monitor.uploadedImage': 'Uploaded Image',
  'products.imageSearch.monitor.createdAt': 'Created',
  'products.imageSearch.monitor.startedAt': 'Started',
  'products.imageSearch.monitor.completedAt': 'Completed',
  'products.imageSearch.monitor.errorCode': 'Error Code',
  'products.imageSearch.monitor.errorMessage': 'Error Message',
  'products.imageSearch.monitor.timeline': 'Timeline',
  'products.imageSearch.monitor.invokeStatus': 'Function Invoke',
  'products.imageSearch.monitor.invokeInvoking': 'Invoking...',
  'products.imageSearch.monitor.invokeInvoked': 'Invoked',
  'products.imageSearch.monitor.invokeFailed': 'Invoke Failed',

  // Image Search Modal
  'products.imageSearch.uploadDescription': 'Upload a reference image to find similar packaging.',
  'products.imageSearch.dropHere': 'Drop your image here',
  'products.imageSearch.orClick': 'or click to browse',
  'products.imageSearch.upload': 'Upload',
  'products.imageSearch.camera': 'Camera',
  'products.imageSearch.takePhoto': 'Take a Photo',
  'products.imageSearch.reupload': 'Re-upload',
  'products.imageSearch.cancel': 'Cancel',
  'products.imageSearch.searchButton': 'Find Similar',

  // List page misc
  'products.clearResult': 'Clear result',
  'products.filters.activeCount': '{{count}} active',
  'products.filters.noShapeData': 'No shape data available yet.',
  'products.filters.noNeckSizeData': 'No neck size data available yet.',
  'products.filters.noUsageData': 'No usage data available yet.',
  'products.filters.noPriceData': 'No price data available yet.',
  'products.filters.noMoqData': 'No MOQ data available yet.',
  'products.card.noImage': 'No image',

  // Detail page
  'detail.breadcrumbHome': 'Home',
  'detail.breadcrumbPackaging': 'Packaging',
  'detail.addedToCart': 'Added to cart! ({{count}} items)',
  'detail.loading': 'Loading product information...',
  'detail.notFoundTitle': 'Product not found',
  'detail.notFoundDesc': 'This product does not exist or has been removed.',
  'detail.backToList': 'Back to product list',
  'detail.inquiry': 'Inquiry',
  'detail.leadTime': 'Lead time',
  'detail.selectedFinishing': 'Selected finishing ({{count}})',
  'detail.reset': 'Reset',
  'detail.finishingNote': 'Selected in finishing preview · Automatically applied when requesting a quote',
  'detail.priceReference': 'Reference Price',
  'detail.perUnit': 'per unit',
  'detail.requestQuoteInquiry': 'Quote inquiry',
  'detail.orderQuantity': 'Order Quantity (MOQ)',
  'detail.priceEstimateNote': 'This is an estimated amount and will be finalized when the quotation is prepared.',
  'detail.moqBelowTitle': 'Below Minimum Order Quantity (MOQ)',
  'detail.moqBelowDesc': 'The MOQ for this product is {{moq}}. Orders below MOQ may incur additional costs or be rejected.',
  'detail.sampleOnly': 'Sample only',
  'detail.samplePriceNote': 'This is a reference price. Unit price by quantity, finishing, exchange rate, and final terms will be confirmed in the quotation.',
  'detail.samplePurchase': 'Sample Purchase',
  'detail.sampleRange': '(0-50 pcs)',
  'detail.sampleBasePrice': 'Sample Reference Price',
  'detail.tabDetails': 'Details',
  'detail.tabReviews': 'Reviews',
  'detail.specifications': 'Specifications',
  'detail.features': 'Key Features',
  'detail.saveProduct': 'Save',
  'detail.shareProduct': 'Share',
  'detail.addToCart': 'Add to Cart',
  'detail.requestQuote': 'Finishing & Quote',
  'detail.noReviews': 'No reviews yet',
  'detail.noReviewsDesc': 'Be the first to leave a review for this product.',
  'detail.reviewCount': '{{count}} reviews',
  'detail.expand': 'More',
  'detail.collapse': 'Collapse',
  'detail.noSpecs': 'No product specifications registered.',
  'detail.noImage': 'No image',
  'detail.imageNotAvailable': 'Image not available',
  'detail.myFinishingImages': 'My finishing images',

  // Finishing preview page
  'finishing.title': 'Finishing Preview',
  'finishing.material': 'Material',
  'finishing.capacity': 'Capacity',
  'finishing.moq': 'MOQ',
  'finishing.refPrice': 'Reference Price',
  'finishing.quoteInquiry': 'Quote inquiry',
  'finishing.selectOptions': 'Select Finishing Options',
  'finishing.selectOptionsDesc': 'Select in order: part → finishing method → color. You can specify each part differently.',
  'finishing.resetAll': 'Reset All',
  'finishing.selectPart': 'Select Part',
  'finishing.selectMethod': 'Finishing Method',
  'finishing.selectColor': 'Select Color',
  'finishing.done': 'Selected',
  'finishing.methodsCount': '{{count}} methods',
  'finishing.selectPartFirst': '- Select a part first',
  'finishing.selectPartHint': 'Select a part on the left to see<br />available finishing methods.',
  'finishing.selectMethodFirst': '- Select a method first',
  'finishing.confirmHint': '- Press the confirm button',
  'finishing.selectMethodHint': 'Select a finishing method in the center<br />to specify a color.',
  'finishing.popularColors': 'Popular Colors',
  'finishing.premium': 'Premium',
  'finishing.custom': 'Custom',
  'finishing.changeColor': 'Change Color',
  'finishing.changeColorHint': 'You can change the color or select a different finishing method.',
  'finishing.reselect': 'Reselect',
  'finishing.confirm': 'Confirm',
  'finishing.selectedCount': '{{count}} finishing selected',
  'finishing.optionsIncluded': 'These options will be included when requesting a quote.',
  'finishing.generating': 'Generating...',
  'finishing.aiPreviewButton': 'AI Finishing Preview',
  'finishing.original': 'Original',
  'finishing.aiFinished': 'AI Finishing',
  'finishing.aiGenerating': 'Generating AI image...',
  'finishing.aiFailed': 'AI image generation failed',
  'finishing.aiFailedHint': 'Please refer to the original image and selected finishing information.',
  'finishing.retry': 'Try Again',
  'finishing.aiImage': 'AI Finishing Image',
  'finishing.aiImageHint': 'Select finishing options and<br />press the AI image processing button',
  'finishing.summary': 'Finishing Summary',
  'finishing.summaryDesc': 'The selected finishing conditions are sent to the server as structured JSON. The server generates an AI prompt and produces the image.',
  'finishing.selectionSummary': 'Selection Summary',
  'finishing.additionalRequest': 'Additional Request (Optional)',
  'finishing.additionalRequestHint': 'Additional requests are sent to the server together with the structured finishing conditions.',
  'finishing.generatePreview': 'Generate Preview',
  'finishing.progressTitle': 'Preview Generation Progress',
  'finishing.currentStatus': 'Current Status',
  'finishing.elapsed': 'Elapsed Time',
  'finishing.message': 'Message',
  'finishing.complete': 'Preview Complete',
  'finishing.aiPreview': 'AI Preview',
  'finishing.generateAgain': 'Generate Again',
  'finishing.useThisPreview': 'Use This Preview',
  'finishing.viewEstimate': 'View Finishing Estimate',
  'finishing.failed': 'Preview Generation Failed',
  'finishing.retryBtn': 'Retry',
  'finishing.editOptions': 'Edit Options',
  'finishing.cancelAndBack': 'Cancel and Go Back',
  'finishing.applySave': 'Apply & Save {{count}} Finishing',
  'finishing.saveUse': 'Save Finishing Image',
  'finishing.colorCount': '{{count}} colors',
  'finishing.cancel': 'Cancel',
  'finishing.pantoneCode': 'Pantone Code',
  'finishing.hexCode': 'Color Code (HEX)',
  'finishing.customColorHint': 'Enter the desired Pantone number and color directly.',
  'finishing.pantonePlaceholder': 'e.g. Pantone 185 C',
  'finishing.noPantone': 'Pantone not specified',
  'finishing.selectThisColor': 'Select This Color',
  'finishing.customName': 'Custom',
  'finishing.pantoneRequired': 'Please enter a Pantone code.',
  'finishing.hexInvalid': 'Please enter a valid HEX color code. (e.g. #FF6B6B)',
  'finishing.metallic': 'Metallic',
  'finishing.pearl': 'Pearl',
  'finishing.softTouch': 'Soft Touch',
  'finishing.additionalRequestPlaceholder': 'e.g. "Make it feel premium."\n"Use a clean studio background."\n"Keep the bottle elegant and minimal."',
};